import { render, staticRenderFns } from "./StudentsMEFormInput.vue?vue&type=template&id=5383ae1a&scoped=true&"
import script from "./StudentsMEFormInput.vue?vue&type=script&lang=js&"
export * from "./StudentsMEFormInput.vue?vue&type=script&lang=js&"
import style0 from "./StudentsMEFormInput.vue?vue&type=style&index=0&id=5383ae1a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5383ae1a",
  null
  
)

export default component.exports